import { stateOptions } from '../../../../shared/helper/states'

export default {
  inject: ['provided'],

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Personal Information">
      <ui-form-item label="First Name" prop="applicant.firstName">
        <ui-form-input name="app_fname" v-model="model.applicant.firstName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Middle Name" prop="applicant.middleName">
        <ui-form-input name="app_mname" v-model="model.applicant.middleName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Last Name" prop="applicant.lastName">
        <ui-form-input name="app_lname" v-model="model.applicant.lastName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Birth Date" prop="applicant.dateOfBirth">
        <ui-date-picker-input v-model="model.applicant.dateOfBirth" />
      </ui-form-item>

      <ui-form-item label="Social Security Number" prop="applicant.ssn">
        <ui-form-input name="app_ssn" v-model="model.applicant.ssn" input-class="width--small" />
      </ui-form-item>
      
      <ui-form-item label="Please provide a photo of your ID" prop="applicant.idFile">
        <ui-form-uppy
          v-model="model.applicant.idFile"
          :params-url="provided.idParamsUrl"
          :max-num-files="1"
          :allowed-types="['.jpg', '.jpeg', '.png', '.gif']"
          :max-file-size="8 * 1025000"
          form-field-name="app_id"
          auto-proceed
          :show-filenames="false"
        />
      </ui-form-item>

      <br>
      <ui-form-item label="Drivers License Number" prop="applicant.driversLicense.number">
        <ui-form-input name="app_dl_num" v-model="model.applicant.driversLicense.number" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Issuing State" prop="applicant.driversLicense.state">
        <ui-form-select
          name="app_dl_state"
          v-model="model.applicant.driversLicense.state"
          :options="stateOptions"
          input-class="inline" />
      </ui-form-item>

      <br>
      <ui-form-item label="Home Phone Number" prop="applicant.phone.home">
        <ui-form-input name="app_home_phone" v-model="model.applicant.phone.home" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Cell Phone Number" prop="applicant.phone.cell">
        <ui-form-input name="app_cell_phone" v-model="model.applicant.phone.cell" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Email" prop="applicant.email">
        <ui-form-input name="app_email" v-model="model.applicant.email" input-class="width--medium" />
      </ui-form-item>

      <br>
      <ui-form-address
        address-label="Service Address"
        name-prefix="app_servadd_"
        prop-prefix="applicant.serviceAddress"
        :address="model.applicant.serviceAddress" />

      <ui-form-item label="Are you the home owner or are you renting?" prop="applicant.ownOrRent">
        <ui-form-radio name="app_own_rent" v-model="model.applicant.ownOrRent" label="Own" />
        <ui-form-radio name="app_own_rent" v-model="model.applicant.ownOrRent" label="Rent" />
      </ui-form-item>

      <template v-if="model.applicant.ownOrRent === 'Rent'">
        <ui-form-item label="Landlord Name" prop="applicant.landlord.name">
          <ui-form-input
            name="app_landlord_name"
            v-model="model.applicant.landlord.name"
            input-class="width--small"
          />
        </ui-form-item>
        <ui-form-item label="Landlord Phone" prop="applicant.landlord.phone">
          <ui-form-input
            name="app_landlord_phone"
            v-model="model.applicant.landlord.phone"
            input-class="width--small"
          />
        </ui-form-item>
      </template>

      <br>
      <ui-form-item prop="applicant.mailingAddress.isDifferentThanService">
        <ui-form-checkbox
          name="app_mailadd_diffThanService"
          v-model="model.applicant.mailingAddress.isDifferentThanService"
          :value="true"
          label="My mailing address is different than my service address" />
      </ui-form-item>

      <template v-if="model.applicant.mailingAddress.isDifferentThanService">
        <ui-form-address
          address-label="Mailing Address"
          name-prefix="app_mailadd_"
          prop-prefix="applicant.mailingAddress"
          :address="model.applicant.mailingAddress" />
      </template>

      <br>
      <p>
        <b>Your Employer (optional)</b>
      </p>
      <ui-form-item label="Name" prop="applicant.employer.name">
        <ui-form-input name="app_employer_name" v-model="model.applicant.employer.name" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Phone Number" prop="applicant.employer.phone">
        <ui-form-input name="app_employer_phone" v-model="model.applicant.employer.phone" input-class="width--small" />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },

  computed: {
    stateOptions() {
      return stateOptions
    },
  },
}
